<template>
  <a v-for="rec in ad.data" :key="rec.id" :href="rec.url" target=”_blank”>
    <div v-if="rec.id == id && rec.active == true" class="top-0 left-0 absolute w-full h-9 bg-indigo-100 text-xxs text-indigo-500 z-50">
      <div class="py-2 px-3 flex justify-between">
        <div class="">
            <span class="font-bold">{{ rec.title }}</span>
            <span class="mx-2">•</span>
            <span class="">{{ rec.message }}</span>
        </div>
        <svg class="text-indigo-600 fill-current" width="20" height="20"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.293 10 7.646 4.354l.708-.708L14.707 10l-6.353 6.354-.708-.707L13.293 10Z"/></svg>
        <!-- <Button @click="test" :style="'secondary'" :class="'w-24'" label="Get Plugin" /> -->
      </div>
    </div>
  </a>
</template>

<script>

import axios from 'axios'

export default {
  name: "Ad",
  data() {
    return {
      ad: {
        table: 'all',
        baseId: 'app3kGIUE8N2asIWO',
        apiKey: 'keyj7h2cXOkcjiUpY',
        data: []
      }
    }
  },
  props:
  [
    "id"
  ],
  mounted() {
    this.getData()
  },
  methods: {
    getData: function () {
      axios({
        url: `https://api.airtable.com/v0/${ this.ad.baseId }/${ this.ad.table }?api_key=${ this.ad.apiKey }`,
        headers: {
          'Authorization': `Bearer ${ this.apiKey }`
        }
      }).then((res) => {
        res.data.records.forEach(record => {
          this.ad.data.push(record.fields)
        });
      });
    }
  }
};
</script>

<style scoped lang="postcss">

</style>